export default __webpack_public_path__ + "static/media/mw16.d6934e82.webp";